import { Typography } from "@mui/material";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import axios from "axios";
import { DownloadLoanAgreementData, postLoanRequestStatus } from "../../Helpers/APIEndPoints/EndPoints";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { useLocation, useNavigate } from "react-router-dom";
import fileDownload from "js-file-download";
import moment from "moment";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../Helpers/Network/APICalls";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { useSelector } from "react-redux";
import BaseModal from "../../Components/BaseModel/BaseModel";

const AgreementDetails = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  //const { id } = location.state;
  const context = getContext();
  const { showLoader, hideLoader, loader } = useContext(LoaderContext);
  const [pdfBytes, setPdfBytes] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const loanParameters = useSelector<any>((state) => state?.LoanModuleReducer?.loanParameters);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSubmited, setIsSubmited] = useState(true);

  enum AgreementDetailsEventTarget {
    DownloadOnClick,
    SubmitOnClick,
    BackOnClick,
  }

  const downloadRegistrationRequest = async () => {
    showLoader();
    let requestParams = { MemberId: context?.MemberId, LoanRequestId: loanParameters?.["LoanId"] };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: DownloadLoanAgreementData,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const contentType = String(response.headers?.["content-type"] || "");
        if (response.status !== 200 || !contentType.includes("application/pdf")) {
          notify(ToastType.Error, "Unable to load the agreement document.");
          return;
        }
        setPdfBytes(response.data);
        var blob = new Blob([response.data], { type: "application/pdf" });
        var url = URL.createObjectURL(blob);
        setPdfUrl(url);
      })
      .catch((error) => {
        notify(ToastType.Error, error);
       
      })
      .finally(() => hideLoader());
  };

  const handleEvents = async (target: AgreementDetailsEventTarget, event: any) => {
    switch (target) {
      case AgreementDetailsEventTarget.DownloadOnClick:
        showLoader();
        fileDownload(pdfBytes, `LoanAgreementForm_` + `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` + `.pdf`);
        setIsSubmited(false);
        hideLoader();
        break;
      case AgreementDetailsEventTarget.SubmitOnClick:
        showLoader();
        let param = {
          StatusId: LoanStatus.LoanModule_MemberSignaturePending,
          LoanRequestId: loanParameters?.["LoanId"],
          UserIdApproval: context?.Id,
          MemberId: context.MemberId,
        };

        let resp = await APICall(postLoanRequestStatus, param);
        if (resp?.Status == ApiStatus.OK) {
          notify(ToastType.Success, "Agreement Successfully submited");
          navigate("/LoanApprovalDashboard");
        } else {
          notify(ToastType.Error, resp?.Message || "Please try again later.");
        }

        hideLoader();
        break;
      case AgreementDetailsEventTarget.BackOnClick:
        navigate("/LoanApprovalDashboard");
        break;
    }
  };

  useEffect(() => {
    downloadRegistrationRequest();
  }, []);

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  const handleCloseModal = () => {
    isModalOpen == true ? setModalOpen(false) : setModalOpen(true);
  };

  const ModalDesign = () => {
    return (
      <>
        <div className={"ModalSize"}>
          <label
            className="d-block"
            style={{
              fontWeight: "bold",
              marginBottom: "10px",
              fontFamily: "var(--bs-body-font-family)",
              fontSize: "var(--bs-body-font-size)",
            }}
          >
            Have You courier the document?
          </label>

          <div className="row justify-content-end no-gutters">
            <div className="col-auto">
              <button
                onClick={() => {
                  setModalOpen(false);
                }}
                className="btn btn-secondary btn-sm mx-2"
              >
                No
              </button>
            </div>
            <div className="col-auto">
              <button onClick={(e) => handleEvents(AgreementDetailsEventTarget.SubmitOnClick, e)} id={"saveBtn"} className="btn btn-secondary btn-sm">
                Yes
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <div>
        <Typography variant="h5" className="d-none">
          Agreement
        </Typography>
      </div>
      <iframe
        style={{
          width: "100%",
          height: "70vh",
        }}
        title="agreement"
        sandbox="allow-downloads allow-popups"
        src={pdfUrl}
      />
      <div className="p-3">
        <ButtonComponent
          className="btn btn-primary ml-3"
          value={"Download"}
          icon={"fa fa-download pr-2"}
          onClick={(e) => handleEvents(AgreementDetailsEventTarget.DownloadOnClick, e)}
        />
        {/* <ButtonComponent className="btn btn-submit ml-3" value={"Submit"} icon={null} disabled={isSubmited} onClick={handleCloseModal} /> */}
        <ButtonComponent
          className="btn btn-cancel ml-3"
          id="cancel"
          value={"Back"}
          icon={null}
          onClick={(e) => handleEvents(AgreementDetailsEventTarget.BackOnClick, e)}
        />
      </div>

      <BaseModal buttonText={""} open={isModalOpen} content={<ModalDesign />} onclose={handleCloseModal} />
    </div>
  );
};

export default AgreementDetails;
